import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { CloneLabComponent } from './clone-lab.component';


@NgModule({
  declarations: [CloneLabComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports:[CloneLabComponent]
})
export class CloneLabModule { }
